import { type as accountType } from '@/iam/account';
import { role } from '@/role/roles';
import { AppUser } from '@/type';
import appUserStorage from './app-user-storage';

export default {
  getAppUser(): AppUser|null {
    return appUserStorage.read();
  },
  isAuthenticated(): boolean {
    return (appUserStorage.read() !== null);
  },
  getUserId(): number|null {
    const appUser = appUserStorage.read();
    return appUser ? appUser.id : null;
  },
  getAccountId(): number|null {
    const appUser = appUserStorage.read();
    return appUser ? appUser.account.id : null;
  },
  getAccountType(): number|null {
    const appUser = appUserStorage.read();
    return appUser ? appUser.account.type : null;
  },
  isServiceProvider(): boolean {
    return this.getAccountType() === accountType.SERVICE_PROVIDER;
  },
  isCustomer(): boolean {
    return this.getAccountType() === accountType.CUSTOMER;
  },
  isClient(): boolean {
    return this.getAccountType() === accountType.CLIENT;
  },
  getRole(): string|null {
    const appUser = appUserStorage.read();
    // Type check required because old app user could be stored
    // and it would have a "roles" prop instead of the newer "role" prop
    if (appUser && typeof appUser.role === 'string') {
      return appUser.role;
    }
    return null;
  },
  getScopes(): string[] {
    const appUser = appUserStorage.read();
    if (appUser && Array.isArray(appUser.scopes)) {
      return appUser.scopes;
    }
    return [];
  },
  hasScope(scope: string): boolean {
    return this.getScopes().includes(scope);
  },
  isSuperAdmin(): boolean {
    return (this.getRole() === role.SUPER_ADMIN);
  },
  isAdmin(): boolean {
    return (this.getRole() === role.ADMIN);
  },
  isManager(): boolean {
    return (this.getRole() === role.MANAGER);
  },
};
